import actionConstants from '../constants/ActionConstants';

const initialState = {
  isFetching: false,
  isSuccess: false,
  success: '',
  error: '',
  permissions: [],
};

export default function genericPermissions(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_GENERIC_ACCESS_PERMISSIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
        isSuccess: false,
        permissions: [],
        error: '',
        success: '',
      };
    case actionConstants.GET_GENERIC_ACCESS_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: action.payload,
        isFetching: false,
        success: action.message,
        isSuccess: true,
      };
    case actionConstants.GET_GENERIC_ACCESS_PERMISSIONS_FAILURE:
      return {
        ...state,
        error: action.message,
        isFetching: false,
      };
    case actionConstants.RESET_ALL_REDUCERS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
